export default {
      id: "ocean-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ocean",
      toString: function () {
        return this.url;
      }
    }